/**
 * RightService
 * Service for Right/Permission entity operations
 * Route: api/rights
 */
import { CrudService } from '../base/CrudService';
/**
 * RightService
 * Handles rights/permissions operations
 */
export class RightService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RightService.DEFAULT_SERVICE_PATH,
            basePath: RightService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    // Note: getAll(), getById(), create(), update(), delete() are inherited from CrudService
    // ==================== GET VIEW ====================
    /**
     * Get all right views
     * GET api/rights/view
     */
    async getView() {
        const response = await this.getViewRaw();
        return response.data ?? [];
    }
    /**
     * Get all right views with full response
     */
    getViewRaw() {
        const endpoint = this.getEndpoint('view', 'view');
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET VIEW BY ID ====================
    /**
     * Get right view by ID
     * GET api/rights/view/{id}
     */
    async getRightView(id) {
        const response = await this.getRightViewRaw(id);
        if (!response.data) {
            throw new Error(`Right ${id} not found`);
        }
        return response.data;
    }
    /**
     * Get right view by ID with full response
     */
    getRightViewRaw(id) {
        const endpoint = this.getEndpoint('view-id', `view/${id}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== GET RIGHTS BY ROLE ====================
    /**
     * Get rights for a specific role
     * GET api/rights/role/{roleId}
     */
    async getByRole(roleId) {
        const response = await this.getByRoleRaw(roleId);
        return response.data ?? [];
    }
    /**
     * Get rights by role with full response
     */
    getByRoleRaw(roleId) {
        const endpoint = this.getEndpoint('role', `role/${roleId}`);
        const url = this.buildUrl(endpoint);
        return this.http.get(url);
    }
    // ==================== ASSIGN RIGHT TO ROLE ====================
    /**
     * Assign right to role
     * POST api/rights/role/{roleId}/assign/{rightId}
     */
    async assignToRole(roleId, rightId) {
        const response = await this.assignToRoleRaw(roleId, rightId);
        return response.success;
    }
    /**
     * Assign right to role with full response
     */
    assignToRoleRaw(roleId, rightId) {
        const endpoint = this.getEndpoint('assign', `role/${roleId}/assign/${rightId}`);
        const url = this.buildUrl(endpoint);
        return this.http.post(url, {});
    }
    // ==================== REVOKE RIGHT FROM ROLE ====================
    /**
     * Revoke right from role
     * DELETE api/rights/role/{roleId}/revoke/{rightId}
     */
    async revokeFromRole(roleId, rightId) {
        const response = await this.revokeFromRoleRaw(roleId, rightId);
        return response.success;
    }
    /**
     * Revoke right from role with full response
     */
    revokeFromRoleRaw(roleId, rightId) {
        const endpoint = this.getEndpoint('revoke', `role/${roleId}/revoke/${rightId}`);
        const url = this.buildUrl(endpoint);
        return this.http.delete(url);
    }
}
RightService.DEFAULT_SERVICE_PATH = 'users';
RightService.BASE_PATH = 'api/rights';
//# sourceMappingURL=RightService.js.map